import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AdminAuthService } from "src/app/services/adminauth.service";

@Injectable()
export class EvaluateCanActivate implements CanActivate {
  constructor(private adminAuthService: AdminAuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.adminAuthService.checkLoginWithTicket(next).pipe(map(isLoggedIn => {
      if (!isLoggedIn) {
        this.router.navigate(["evaluatelogin", next.params.id]);
      }
      return isLoggedIn;
    }));
  }
}
